export function getLevelsDataQuery(){
    let q = `select concat(timeFrame, '_', CAST(value AS String) ) option, * from  OptionFlow.levels where timeFrame != 'month' `
    return q
}